var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRefresh = function SvgRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M18.363 1.67H15.52c4.6 3.088 5.854 9.266 2.843 13.858C15.27 20.119 9.08 21.37 4.48 18.366-.12 15.277-1.374 9.1 1.637 4.508 3.309 1.92 6.069.334 9.164.083V1.67h.083c-4.6.417-7.945 4.508-7.61 9.1.418 4.59 4.432 8.014 9.032 7.596 4.6-.417 8.029-4.425 7.61-9.016-.25-2.755-1.756-5.176-4.181-6.512v3.006c0 .5-.335.835-.836.835-.502 0-.837-.334-.837-.835V.834c0-.5.335-.834.837-.834h5.017c.502 0 .837.334.837.835 0 .5-.251.835-.753.835Z"
  })));
};
export default SvgRefresh;